import styled from "styled-components";

export const BreadCrampWrapper = styled.div`
  display: flex;
  align-items: center;
  z-index: 1;
  position: relative;
  & a {
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    color: ${(props) => (props.whiteText ? "#fff" : (props) => props.theme.textColor)};
    @media (max-width: 991.98px) {
      font-size: 14px;
      line-height: 14px;
    }
  }
  & svg {
    width: 8px;
    margin: 0 5px;
    & path {
      fill: ${(props) => (props.whiteText ? "#fff" : (props) => props.theme.textColor)};
    }
  }
`;
